// 环境配置
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080';
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || 'NexusInflu';
export const APP_VERSION = '1.0.0';

// 认证配置
export const AUTH_CONFIG = {
  TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  TOKEN_EXPIRE_BUFFER: 5 * 60 * 1000, // 5分钟缓冲
};

// 分页配置
export const PAGINATION_CONFIG = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
};

// 角色定义
export const ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  OPERATOR: 'operator',
  VIEWER: 'viewer',
} as const;

// 订阅版本
export const SUBSCRIPTION_PLANS = {
  TRIAL: 'trial',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise',
} as const;

// 功能配额配置（按版本）
export const QUOTA_CONFIG = {
  [SUBSCRIPTION_PLANS.TRIAL]: {
    requirement_analysis: 10,
    product_insight: 5,
    pricing: 5,
    reference_influencers: 5,
    proposal_excel: 10,
    proposal_ppt: 0,
    scout_search: 100,
    influencer_evaluation: 50,
    outreach_insight: 20,
    outreach_generate: 20,
    email_send: 10,
    seats: 3,
    storage_gb: 1,
  },
  [SUBSCRIPTION_PLANS.STARTER]: {
    requirement_analysis: 30,
    product_insight: 15,
    pricing: 15,
    reference_influencers: 15,
    proposal_excel: 10,
    proposal_ppt: 0,
    scout_search: 300,
    influencer_evaluation: 100,
    outreach_insight: 0,
    outreach_generate: 0,
    email_send: 0,
    seats: 3,
    storage_gb: 1,
  },
  [SUBSCRIPTION_PLANS.PROFESSIONAL]: {
    requirement_analysis: 100,
    product_insight: 50,
    pricing: 50,
    reference_influencers: 50,
    proposal_excel: 30,
    proposal_ppt: 15,
    scout_search: 1000,
    influencer_evaluation: 500,
    outreach_insight: 100,
    outreach_generate: 200,
    email_send: 200,
    seats: 10,
    storage_gb: 10,
  },
  [SUBSCRIPTION_PLANS.ENTERPRISE]: {
    requirement_analysis: Infinity,
    product_insight: Infinity,
    pricing: Infinity,
    reference_influencers: Infinity,
    proposal_excel: Infinity,
    proposal_ppt: Infinity,
    scout_search: Infinity,
    influencer_evaluation: Infinity,
    outreach_insight: Infinity,
    outreach_generate: Infinity,
    email_send: Infinity,
    seats: Infinity,
    storage_gb: Infinity,
  },
};
